import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Logger } from '../shared/utils/logger.util';

@Injectable({
  providedIn: 'root',
})
export class UserPreferenceService {
  private readonly PREFIX = 'ics_prefs_';

  // Preference Keys
  static readonly KEYS = {
    REFERRAL_LIST_PAGINATION: 'referral_list_pagination',
    REFERRAL_LIST_FILTERS: 'referral_list_filters',
    REFERRAL_LIST_SORT: 'referral_list_sort',
  };

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  getPreference<T>(key: string): T | null {
    if (!isPlatformBrowser(this.platformId)) {
      return null;
    }

    try {
      const item = localStorage.getItem(this.PREFIX + key);
      return item ? JSON.parse(item) : null;
    } catch (e) {
      Logger.warn('Error reading from localStorage', e);
      return null;
    }
  }

  setPreference<T>(key: string, value: T): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    try {
      localStorage.setItem(this.PREFIX + key, JSON.stringify(value));
    } catch (e) {
      Logger.warn('Error writing to localStorage', e);
    }
  }

  removePreference(key: string): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    try {
      localStorage.removeItem(this.PREFIX + key);
    } catch (e) {
      Logger.warn('Error removing from localStorage', e);
    }
  }
}
